import type {CoreEntityType} from 'nutshell-core/types';

import type {UpdateSavedFilter_filterUpdate_filter as Filter} from 'nutshell-graphql-types';

export const ACCOUNTS_LIST_TYPE = 0;
export const CONTACTS_LIST_TYPE = 1;
export const LEADS_LIST_TYPE = 2;
export const AUDIENCE_LIST_TYPE = 18;

export function getSavedFilterTypeForGraphQL(entityType: CoreEntityType): number {
    switch (entityType) {
        case 'accounts':
            return ACCOUNTS_LIST_TYPE;
        case 'contacts':
            return CONTACTS_LIST_TYPE;
        case 'leads':
        default:
            return LEADS_LIST_TYPE;
    }
}

export function buildSavedListObjectForRedux(
    filter: Filter,
    entityType: CoreEntityType,
    value: string
) {
    return {
        id: filter.id,
        type: 'filters',
        isUpdateable: filter.isUpdateable,
        isDeleteable: filter.isUpdateable,
        createdTime: filter.createdTime,
        href: `${window.location.origin}/rest/filters/${filter.id}`,
        isShared: filter.isShared,
        isImmutable: filter.isImmutable,
        name: filter.name,
        reportType: `entity_list_${entityType}`,
        value: value,
        description: filter.description,
        creatorUserName: filter.creatorUser && filter.creatorUser.name,
        links: {
            user: filter.creatorUser && filter.creatorUser.id,
            usersAndTeams: [],
        },
    };
}
